import { render } from "./Educator.vue?vue&type=template&id=1f1ee5eb&scoped=true"
import script from "./Educator.vue?vue&type=script&lang=js"
export * from "./Educator.vue?vue&type=script&lang=js"

import "./Educator.vue?vue&type=style&index=0&id=1f1ee5eb&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1f1ee5eb"

export default script